import type { CoreBrand, CoreState } from '../../types'
import { findActiveBrand } from '../common/findActiveBrand'

export const getActiveBrandLinks = (
  state: CoreState
): CoreBrand['links'] | undefined => {
  return findActiveBrand(state)?.links
}
